
import { WDFormBasic } from './wd-form-basic';
import { WDFormDate } from './wd-form-date';

export class WDFormDaterange extends WDFormBasic
{

	#beginCfg = null;
	#endCfg = null;
	#beginForm = null;
	#endForm = null;

	constructor(cfg)
	{
		super( wdc('<div/>'), cfg);

		this.#beginCfg = Object.assign({}, cfg);
		this.#endCfg = Object.assign({}, cfg);

		this.#beginCfg.name += '[begin]';
		this.#endCfg.name += '[end]';

		//let's see about this
		if (this.#beginCfg.value_begin) this.#beginCfg.value = this.#beginCfg.value_begin;
		if (this.#endCfg.value_end) this.#endCfg.value = this.#endCfg.value_end;

		//build the forms	
		this.#beginCfg.type = 'date';
		this.#endCfg.type = 'date';

		this.#beginForm = new WDFormDate(this.#beginCfg);
		this.#endForm = new WDFormDate(this.#endCfg);

		this.bubbleEvents(this.#beginForm,['value:set','change']);
		this.bubbleEvents(this.#endForm, ['value:set','change']);
		//
		this.append(this.#beginForm);
		this.append(this.#endForm);
	};

	/**
		*/
	get value()
	{
		let beginVal = this.#beginForm.value;
		let endVal = this.#endForm.value;
		let ret = null;

		if (beginVal || endVal)
		{
			ret = {};
			if (beginVal) ret.begin = beginVal;
			if (endVal) ret.end = endVal;
		}

		return ret;
	};

	set value(valobj)
	{
		if (valobj.begin) this.#beginForm.value = valobj.begin;
		if (valobj.end) this.#endForm.value = valobj.end;
		this.trigger('value:set');
	};

	cleanupCallback()
	{
		// Clean up child forms
		if (this.#beginForm) {
			this.#beginForm = null;
		}

		if (this.#endForm) {
			this.#endForm = null;
		}

		// Clear config references
		this.#beginCfg = null;
		this.#endCfg = null;

		super.cleanupCallback();
	}

};

customElements.define('wd-form-daterange', WDFormDaterange);

